import React from "react";
import useVesselOwnerchangepass from "../Libs/changevpassHook";
import { ReactComponent as EyeoffIcon } from "../../Asset/eye-off.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";


const UpdateVesselOwnerPass = () => {
    const {
        handleChange,
        handleFormSubmit,
        loading,
        password,
        passwordCurrent,
        confirmPassword,
        error,
        success,
        handShowpass,
        showPass,
        handShowpass2,
        showPass2,
        handShowpass3,
        showPass3,
      } = useVesselOwnerchangepass();

      const [activeSection, setActiveSection] = useState("updatevpass");
  const activeStyle = {
    border: "1px solid #0963EB",
  };
    
      const navigate = useNavigate();
    
      return (
        <div className="update-pass-container">
          <div className="wrap">

          
          <div className="switch">
        <div
          className="per-info"
          onClick={() => {
            setActiveSection("profile_v");
            navigate("/dashboard/profile_v");
          }}
          style={activeSection === "profile_v" ? activeStyle : {}}
        >
          <h3>Personal Info</h3>
          <p>Manage personal details</p>
        </div>
        <div className="document" onClick={() => {
          setActiveSection("updates");
          navigate("/dashboard/updates")
        }}
        style={activeSection === "updates" ? activeStyle : {}}
        >
          <h3>Documents</h3>
          <p>Update License and other documents</p>
        </div>

        <div className="change-pass" onClick={() => {
          setActiveSection("updatevpass");
          navigate("/dashboard/updatevpass")
        }}
        style={activeSection === "updatevpass" ? activeStyle : {}}
        >
          <h3>Password</h3>
          <p>Change and manage password</p>
        </div>
      </div>
          <form onSubmit={handleFormSubmit}>
          <IoArrowBack onClick={() => navigate("/mobile_v")} className="mobile-nav"  />
            <h2>Change password</h2>
            <label>
              Old password
              <div>
                <input
                  type={showPass ? "text" : "password"}
                  name="passwordCurrent"
                  value={passwordCurrent}
                  onChange={handleChange}
                  placeholder="Old password"
                />
                <EyeoffIcon onClick={handShowpass} />
              </div>
            </label>
    
            <label>
              New password
              <div>
                <input
                  type={showPass2 ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={handleChange}
                  placeholder="New password"
                />
                <EyeoffIcon onClick={handShowpass2} />
              </div>
            </label>
    
            <label>
              Confirm new password
              <div>
                <input
                  type={showPass3 ? "text" : "password"}
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm new password"
                />
                <EyeoffIcon onClick={handShowpass3} />
              </div>
            </label>
            <button disabled={loading}>{loading ? "Updating..." : "Submit"}</button>
            {error && <p className="error">{error}</p>}
            {success && <p className="success">{success}</p>}
          </form>
          </div>
        </div>
      );
}
 
export default UpdateVesselOwnerPass;